import { Link } from 'react-router-dom';

const STATS = [
  { value: '1,200+', label: '收录漫画作品' },
  { value: '86', label: '合作连载作者' },
  { value: '9,600+', label: '动漫资讯文章' },
  { value: 'Daily', label: '每日内容更新' },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-8">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-secondary-50">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-label font-500 text-primary-800">
              <i className="ri-leaf-line" />
              关于漫蛙
            </span>
            <h2 className="mt-4 font-heading text-2xl font-800 text-foreground-950 md:text-3xl">
              一个属于动漫爱好者的内容频道
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              漫蛙漫画动漫频道专注漫画与动画内容的展示与资讯传播。我们希望把最新的动漫动态、值得一看的漫画作品，用清晰、舒适的方式呈现给每一位读者。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从热门连载到经典回顾，从行业观察到深度评论，你可以在这里按类型、地区、连载状态自由筛选，也可以直接搜索心仪的作品。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/comics"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-500 text-background-50 transition-colors hover:bg-primary-600"
              >
                开始浏览作品
              </Link>
              <Link
                to="/category/news"
                className="cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-2.5 text-sm font-label font-500 text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
              >
                查看最新资讯
              </Link>
            </div>
          </div>
          <div className="relative min-h-[240px] lg:min-h-full">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20flat%20illustration%20of%20a%20cozy%20reading%20space%20with%20stacked%20colorful%20manga%20books%2C%20a%20small%20green%20plant%20and%20a%20laptop%20showing%20comic%20pages%2C%20soft%20white%20background%20with%20emerald%20and%20amber%20accents%2C%20clean%20minimal%20style%2C%20wide%20landscape%20composition&width=900&height=700&seq=about-manwa-001&orientation=landscape"
              alt="漫蛙漫画动漫频道阅读空间插画"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-px bg-background-200 lg:grid-cols-4">
          {STATS.map((stat) => (
            <div key={stat.label} className="bg-background-50 px-6 py-6 text-center">
              <p className="font-heading text-2xl font-800 text-primary-700">{stat.value}</p>
              <p className="mt-1 text-xs font-label text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}